export const isImageVariable = variable => ['staticImage', 'dynamicImage'].includes(variable.type);
